// extracted by mini-css-extract-plugin
module.exports = {"containerCreate":"Form_containerCreate__X8IH3","form":"Form_form__SgHMH","label":"Form_label__UdcyA","input":"Form_input__4O0Yw","Submmit":"Form_Submmit__25mua"};